export default "__VITE_ASSET__38016a5c__"